var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_2387",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 29,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00769043 27.9824L27.9564 27.9824L27.9564 0.0183105L-0.00769043 0.0183105L-0.00769043 27.9824Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_2387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3553 5.24109C18.5325 5.24099 18.7055 5.29465 18.8516 5.39499C18.9977 5.49532 19.1099 5.6376 19.1734 5.80304C19.2369 5.96848 19.2488 6.1493 19.2074 6.3216C19.166 6.49391 19.0733 6.64961 18.9415 6.76813L10.9058 13.9988L18.9415 21.2306C19.1037 21.3887 19.1985 21.6035 19.2058 21.8299C19.2132 22.0563 19.1327 22.2768 18.9811 22.4452C18.8295 22.6135 18.6187 22.7167 18.3927 22.7331C18.1668 22.7494 17.9432 22.6777 17.769 22.5329L9.01025 14.65C8.91988 14.5677 8.84768 14.4675 8.79827 14.3557C8.74887 14.2439 8.72335 14.1231 8.72335 14.0008C8.72335 13.8786 8.74887 13.7578 8.79827 13.646C8.84768 13.5342 8.91988 13.434 9.01025 13.3517L17.769 5.46879C17.93 5.32421 18.1389 5.2445 18.3553 5.24508",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/PrevArrow.277d709077eeb7fbd2f26e6b132e2997.svg";
export { ForwardRef as ReactComponent };